import React from "react";
import { Container, Row, Col } from "reactstrap";
import VideoWelcomeList from "./VideoWelcomeList";

const Videos = () => {
  return (
    <Container fluid className="p-0">
      <h1 className="page-title">Homepage videos</h1>
      <Row>
        <Col lg="12" className="d-flex">
          <VideoWelcomeList />
        </Col>
      </Row>
    </Container>
  );
};

export default Videos;
